import { useCallback, useEffect } from 'react';
export var useOnVisibilityChange = function useOnVisibilityChange(_ref) {
  var onVisible = _ref.onVisible,
    onHidden = _ref.onHidden;
  var OnVisibilityChange = useCallback(function () {
    if (document.visibilityState === 'visible') {
      onVisible();
    } else {
      onHidden();
    }
  }, [onVisible, onHidden]);
  useEffect(function () {
    window.addEventListener('visibilitychange', OnVisibilityChange);
    return function () {
      return window.removeEventListener('visibilitychange', OnVisibilityChange);
    };
  }, [OnVisibilityChange]);
};
export default useOnVisibilityChange;